import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3ed2f6fe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-panel" }
const _hoisted_2 = { class: "text-military-green-500" }
const _hoisted_3 = { class: "form" }
const _hoisted_4 = { class: "input" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Course", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  value: ""
}, "Select Course", -1))
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "input" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Class Name", -1))
const _hoisted_10 = { class: "input" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Start Date", -1))
const _hoisted_12 = ["min", "max"]
const _hoisted_13 = { class: "input" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "End Date", -1))
const _hoisted_15 = ["min"]
const _hoisted_16 = { class: "flex gap-2" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Status: ", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Active", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Archived", -1))
const _hoisted_20 = { class: "actions" }
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" Save ")
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" Cancel ")

import { computed, ref, PropType } from 'vue';
import { Class } from '@/models/Class';
import { Course } from '@/models/Course';
import { generateCode, dateFormatter } from '../../utils/utils';
import ButtonComponent from '@/components/ButtonComponent.vue';
import CheckBox from '@/components/CheckBox.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'EditClassPanelComponent',
  props: {
  courses: {
    type: Object as PropType<Course[]>,
    required: true
  },
  courseClass: {
    type: Object as PropType<Class>,
    required: true
  }
},
  emits: ['save', 'cancel'],
  setup(__props, { emit }) {

const props = __props


const courseOptions = computed(() => {
  return props.courses.map((course) => ({
    value: course.id,
    text: course.courseName
  }));
});



const selectedCourse = ref(props.courseClass.courseId);
const classNameInput = ref(props.courseClass.name);
const startDate = props.courseClass.startDate.toISOString().substring(0, 10);
const startDateInput = ref(startDate);
const endDate = props.courseClass.endDate.toISOString().substring(0, 10);
const endDateInput = ref(endDate);
const isActiveInput = ref(props.courseClass.isActive);
const modifyTitle = computed(() => {
  if (props.courseClass.id) {
    return 'Edit Class';
  }
  return 'Create Class';
});

const MAX_END_DATE = '12/29/2099';
const currentDate = new Date();
currentDate.setUTCHours(0, 0, 0, 0);
const currentDateString = currentDate.toISOString().substring(0, 10);

const isValidDate = (startDateInput: string, endDateInput: string): boolean => {
  return !(
    isNaN(Date.parse(startDateInput)) || isNaN(Date.parse(endDateInput))
  );
};

const isValid = computed(() => {
  return (
    isValidDate(startDateInput.value, endDateInput.value) &&
    selectedCourse.value !== '' &&
    classNameInput.value !== '' &&
    startDateInput.value !== '' &&
    endDateInput.value !== ''
  );
});

const handleArchiveClass = () => {
  isActiveInput.value = !isActiveInput.value;
};

const handleSaveClass = () => {
  const inviteCode = generateCode();
  const _class = props.courseClass;
  _class.name = classNameInput.value;
  _class.courseId = selectedCourse.value;
  _class.startDate = new Date(dateFormatter(startDateInput.value));
  _class.endDate = new Date(dateFormatter(endDateInput.value));
  if (!_class.inviteCode || _class.inviteCode === '') {
    _class.inviteCode = inviteCode;
  }
  _class.isActive = isActiveInput.value;
  emit('save');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("h5", _hoisted_2, _toDisplayString(_unref(modifyTitle)), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedCourse).value = $event)),
          class: "input-field",
          "data-cy": "course-select"
        }, [
          _hoisted_6,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(courseOptions), (course) => {
            return (_openBlock(), _createElementBlock("option", {
              value: course.value,
              key: course.value
            }, _toDisplayString(course.text), 9, _hoisted_7))
          }), 128))
        ], 512), [
          [_vModelSelect, selectedCourse.value]
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _withDirectives(_createElementVNode("input", {
          type: "text",
          class: "input-field",
          placeholder: "Class Name",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((classNameInput).value = $event)),
          maxlength: "5",
          "data-cy": "class-name-input"
        }, null, 512), [
          [_vModelText, classNameInput.value]
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _withDirectives(_createElementVNode("input", {
          type: "date",
          class: "input-field",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((startDateInput).value = $event)),
          "data-cy": "start-date-input",
          min: _unref(currentDateString),
          max: endDateInput.value,
          onkeydown: "false"
        }, null, 8, _hoisted_12), [
          [_vModelText, startDateInput.value]
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _hoisted_14,
        _withDirectives(_createElementVNode("input", {
          type: "date",
          class: "input-field",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((endDateInput).value = $event)),
          "data-cy": "end-date-input",
          min: startDateInput.value,
          max: MAX_END_DATE,
          onkeydown: "false"
        }, null, 8, _hoisted_15), [
          [_vModelText, endDateInput.value]
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _hoisted_17,
        _createVNode(CheckBox, {
          class: "checkbox",
          state: isActiveInput.value,
          onClick: handleArchiveClass
        }, null, 8, ["state"]),
        _hoisted_18,
        _createVNode(CheckBox, {
          class: "checkbox",
          state: !isActiveInput.value,
          onClick: handleArchiveClass
        }, null, 8, ["state"]),
        _hoisted_19
      ])
    ]),
    _createElementVNode("div", _hoisted_20, [
      _createVNode(ButtonComponent, {
        "color-type": "tertiary",
        size: "small",
        onClick: handleSaveClass,
        "data-cy": "save-class-button",
        disabled: !_unref(isValid)
      }, {
        default: _withCtx(() => [
          _hoisted_21
        ]),
        _: 1
      }, 8, ["disabled"]),
      _createVNode(ButtonComponent, {
        "color-type": "tertiary",
        size: "small",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('cancel'))),
        "data-cy": "cancel-edit-button"
      }, {
        default: _withCtx(() => [
          _hoisted_22
        ]),
        _: 1
      })
    ])
  ]))
}
}

})